<template>
  <div>
    <v-row>
      <v-col>
        <v-tabs
          v-model="userTab"
          fixed-tabs
          align-with-title
          class="user-tabs"
        >
          <v-tab
            v-for="tab in tabs"
            :key="tab.icon"
            @click="getCargo"
          >
            <v-icon
              size="20"
              class="me-3"
            >
              {{ tab.icon }}
            </v-icon>

            <span>{{ tab.title }}</span>
          </v-tab>

          <v-tab :to="{ name: 'cargos' }">
            <v-icon color="error">
              {{ icons.mdiCloseCircleOutline }}
            </v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items
          id="user-tabs-content"
          v-model="userTab"
          class="mt-5"
        >
          <div style="min-height: 4px">
            <v-progress-linear
              v-if="loading"
              indeterminate
            />
          </div>

          <v-tab-item>
            <cargo-tab-connections
              :key="cargo.id"
              :connections-data="cargo"
              :acesso-put="acessoPut"
              @confirmar-atualizacao="getCargo"
            />
          </v-tab-item>

          <v-tab-item>
            <cargo-tab-departamentos
              :cargo-id="cargo.id"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.v-slide-group__content{
  display: flex;
  flex: 1 0 auto;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  justify-content: space-between;
}
</style>

<script>
import { ref } from '@vue/composition-api'
import { mapState } from 'pinia'
import { mdiBookmarkOutline, mdiCloseCircleOutline, mdiOfficeBuilding } from '@mdi/js'
import router from '@/router'
import CargoTabConnections from '@/views/cargo/CargoTabConnections.vue'
import CargoTabDepartamentos from '@/views/cargo/CargoTabDepartamentos.vue'
import useAuthStore from '@/store/auth'
import CargoService from '@/services/modules/CargoService'

export default {
  components: {
    CargoTabConnections,
    CargoTabDepartamentos,
  },

  data() {
    return {
      cargo: {},
      loading: false,
      idPut: 1016,
      acessoPut: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    this.getCargo()
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPut)) {
        this.acessoPut = false
      }
    },

    async getCargo() {
      this.loading = true

      try {
        this.cargo = await CargoService.getById(router.currentRoute.params.id)

        setTimeout(() => {
          this.loading = false
        }, 1000)
      } catch {
        this.loading = false
      }
    },
  },

  setup() {
    const userData = ref({})
    const userTab = ref('')

    const tabs = [
      { icon: mdiBookmarkOutline, title: 'CARGO' },
      { icon: mdiOfficeBuilding, title: 'Departamentos' },
    ]

    return {
      tabs,
      userTab,
      userData,
      icons: {
        mdiCloseCircleOutline,
      },
    }
  },
}
</script>
